import { User } from 'mission-control-common-components';
import type React from 'react';
import { useEffect } from 'react';

import { getCognitoDetailsForLogin } from '../../utils/cognitoDetails';

const OauthCallback: React.FC = () => {
  const oauthCallback = async (): Promise<void> => {
    await User.oauthCallback({ redirectToLoginOnError: true }, undefined, await getCognitoDetailsForLogin());
  };

  useEffect(() => {
    oauthCallback();
  }, []);

  return null;
};

export default OauthCallback;
